import { useCanonicallsContinuityCarry } from "./CanonicallsContinuityCarryProvider";
import { coalesceContinuityCarry, formatDigestFragment, lineageLabel } from "../../lib/canonicallsContinuityCarry";
import { CANONICALLS_CAPSULE } from "../../lib/canonicallsCopy";

/** Slim rail — supports the Canonical Source Card below, does not duplicate the object. */
export function ContinuityCapsule() {
  const { effectiveCarry: rawCarry } = useCanonicallsContinuityCarry();
  const effectiveCarry = coalesceContinuityCarry(rawCarry);

  const evidenceCount = effectiveCarry.evidence.length;
  const digestFragment = formatDigestFragment(effectiveCarry.digest);

  return (
    <aside className="canonicalls-capsule canonicalls-capsule--support" aria-label="Traversal support">
      <div className="canonicalls-capsule__thread" aria-hidden />
      <p className="canonicalls-capsule__label">{CANONICALLS_CAPSULE.label}</p>
      <div className="canonicalls-capsule__row">
        <span className="canonicalls-capsule__support">{CANONICALLS_CAPSULE.supportHint}</span>
        <span className="canonicalls-capsule__rail">{lineageLabel(effectiveCarry.lineageState)}</span>
      </div>
      {evidenceCount > 0 || digestFragment ? (
        <div className="canonicalls-capsule__meta" role="status">
          {evidenceCount > 0 ? (
            <span className="canonicalls-capsule__meta-chip canonicalls-capsule__meta-chip--evidence">
              {CANONICALLS_CAPSULE.evidenceAttached(evidenceCount)}
            </span>
          ) : null}
          {digestFragment ? (
            <span className="canonicalls-capsule__meta-chip canonicalls-capsule__meta-chip--digest">
              <span className="canonicalls-capsule__meta-label">{CANONICALLS_CAPSULE.digestPrefix}</span>
              <code>{digestFragment}</code>
            </span>
          ) : null}
        </div>
      ) : null}
    </aside>
  );
}
